export default __webpack_public_path__ + "static/media/FORD.598f2fd1.jpeg";